module.exports = __webpack_public_path__ + "img/jarom-vogel-monkey.5baf058.jpg";